// Inject spinner styles once
(function () {
  if (document.getElementById('upsell-spinner-styles')) return;
  const style = document.createElement('style');
  style.id = 'upsell-spinner-styles';
  style.textContent = `
    @keyframes upsell-spin {
      to { transform: rotate(360deg); }
    }
    .upsell-btn-spinner {
      display: inline-block;
      width: 18px;
      height: 18px;
      border: 2.5px solid rgba(255, 255, 255, 0.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: upsell-spin 0.7s linear infinite;
      vertical-align: middle;
    }
  `;
  document.head.appendChild(style);
})();

function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    const fmt = window.Shopify.money_with_currency_format || window.Shopify.money_format;
    return window.Shopify.formatMoney(cents, fmt);
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
  }).format(cents / 100);
}

function updateCartItemCount(count) {
  const heading = document.querySelector('.drawer__heading');
  if (!heading) return;
  let countEl = heading.querySelector('.cart-item-count');
  if (count > 0) {
    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'cart-item-count';
      heading.appendChild(countEl);
    }
    countEl.textContent = count;
  } else {
    if (countEl) countEl.remove();
  }
}

function updateCartTotals(cart) {
  const originalEl = document.querySelector('.original_total');
  const totalEl = document.querySelector('.totals__total-value');
  if (originalEl) originalEl.textContent = formatMoney(cart.original_total_price);
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

function updateFreeShippingMsg(cart) {
  const row = document.querySelector('.cart-drawer__footer-shipping[data-fsn-threshold]');
  if (!row) return;

  const threshold = parseInt(row.dataset.fsnThreshold, 10);
  if (!threshold) return;

  const valueSpan = row.querySelector('.cart-fsn-value');
  if (!valueSpan) return;

  const remaining = threshold - cart.total_price;

  if (remaining <= 0) {
    valueSpan.className = 'cart-fsn-value';
    valueSpan.removeAttribute('style');
    valueSpan.textContent = row.dataset.fsnMet || 'Free';
  } else {
    const prefix = row.dataset.fsnPrefix || 'Order';
    const suffix = row.dataset.fsnSuffix || 'more and Shipping is on us!';
    valueSpan.className = 'cart-fsn-value cart-drawer__free-shipping-msg';
    valueSpan.style.cssText = `font-size:${row.dataset.fsnSize || 12}px; font-weight:${row.dataset.fsnWeight || '500'}; color:${row.dataset.fsnColor || '#555555'}; text-align:right;`;
    valueSpan.innerHTML = `${prefix} <strong>${formatMoney(remaining)}</strong> ${suffix}`;
  }
}

function updateHeaderCartCount(count) {
  const bubbleEl = document.getElementById('cart-icon-bubble');
  if (!bubbleEl) return;
  let countBubble = bubbleEl.querySelector('.cart-count-bubble');
  if (count > 0) {
    if (!countBubble) {
      countBubble = document.createElement('div');
      countBubble.className = 'cart-count-bubble';
      bubbleEl.appendChild(countBubble);
    }
    countBubble.innerHTML =
      `<span aria-hidden="true">${count < 100 ? count : ''}</span>` +
      `<span class="visually-hidden">${count} items in cart</span>`;
  } else if (countBubble) {
    countBubble.remove();
  }
}

function updateCartAnnouncement(isEmpty) {
  const wrapper = document.querySelector('.drawer__header-announcement');
  if (!wrapper) return;
  if (isEmpty) {
    if (window.cartReservation) window.cartReservation.stopCountdown();
    wrapper.innerHTML = '<span class="drawer__header-announcement-text">Your Cart is Empty, Choose a Pack now!</span>';
  } else {
    // Re-attach the reservation span if it was replaced by the empty message
    const reservationEl = wrapper.querySelector('#cart-reservation');
    if (reservationEl && window.cartReservation) {
      window.cartReservation.setupTimer();
    }
  }
}

// Prevents the 2-second polling from triggering empty-state side effects
// (announcement flash, drawer refresh) while a clear→add upgrade is in flight.
let _cartBulkUpdating = false;

function refreshCartDrawer() {
  return fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then((r) => r.json())
    .then((data) => {
      if (data['cart-drawer']) {
        const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

        // Replace cart items, the full footer (includes totals, checkout, Shop All CTA, reviews),
        // and the announcement bar
        for (const selector of ['cart-drawer-items', '.drawer__footer', '.drawer__header-announcement']) {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        }

        // Handle the empty-state block (.drawer__inner-empty) which only exists in the
        // server-rendered HTML when the cart is empty.
        const srcInnerEmpty = html.querySelector('.drawer__inner-empty');
        const currentInnerEmpty = document.querySelector('.drawer__inner-empty');
        if (srcInnerEmpty && !currentInnerEmpty) {
          // Cart just became empty — insert the empty-state block after the header
          const header = document.querySelector('.cart-drawer .drawer__header');
          if (header) header.insertAdjacentElement('afterend', srcInnerEmpty);
        } else if (!srcInnerEmpty && currentInnerEmpty) {
          // Cart now has items — remove the empty-state block
          currentInnerEmpty.remove();
        } else if (srcInnerEmpty && currentInnerEmpty) {
          currentInnerEmpty.replaceWith(srcInnerEmpty);
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const srcCartDrawer = html.querySelector('cart-drawer');
        if (cartDrawer && srcCartDrawer) {
          cartDrawer.classList.toggle('is-empty', srcCartDrawer.classList.contains('is-empty'));
        }
        // Sync item count from freshly rendered HTML
        const srcCount = html.querySelector('.cart-item-count');
        updateCartItemCount(srcCount ? parseInt(srcCount.textContent, 10) : 0);

        // Keep the empty-cart icon in sync with the header icon after DOM rebuild
        syncEmptyCartIcon();
      }
      if (data['cart-icon-bubble']) {
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl) {
          const parsed = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          // Only swap the count bubble — never replace the SVG icon so the
          // custom cart icon set in header section settings is always preserved.
          const newCount = parsed.querySelector('.cart-count-bubble');
          const currentCount = bubbleEl.querySelector('.cart-count-bubble');
          if (newCount && currentCount) {
            currentCount.replaceWith(newCount);
          } else if (newCount) {
            bubbleEl.appendChild(newCount);
          } else if (currentCount) {
            currentCount.remove();
          }
        }
      }
    })
    .catch((err) => console.error('refreshCartDrawer error:', err));
}

class CartReservation {
  constructor() {
    this.reservationTime = null; // Will be set from data attribute
    this.timerElement = null;
    this.countdownInterval = null;
    this.expirationTime = null;
    this.previousCartState = {};
    this.init();
  }

  init() {
    // Listen for section rendering
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('cart-drawer')) {
        this.setupTimer();
      }
    });

    // Listen for cart drawer open
    document.addEventListener('cart-drawer:open', () => {
      this.setupTimer();
    });

    // Listen for cart drawer close
    document.addEventListener('cart-drawer:close', () => {
      this.stopCountdown();
    });

    // Initialize cart monitoring
    this.initCartMonitoring();
  }

  initCartMonitoring() {
    // Save the original fetch method
    const originalFetch = window.fetch;

    // Override fetch to monitor cart-related requests
    window.fetch = async function(...args) {
      const url = args[0];
      if (typeof url === 'string' && (
        url.includes('/cart/add.js') ||
        url.includes('/cart/update.js') ||
        url.includes('/cart/change') ||   // matches /cart/change and /cart/change.js
        url.includes('/cart/clear.js')
      )) {
        // Wait for the original fetch to complete
        const response = await originalFetch.apply(window, args);
        
        // Clone the response so we can read it multiple times
        const clone = response.clone();
        
        // Check if the request was successful
        if (response.ok) {
          try {
            const data = await clone.json();
            if (data) {
              // Skip timer setup during a bulk clear→add so the timer doesn't
              // briefly stop and restart mid-operation.
              if (!_cartBulkUpdating) {
                window.cartReservation.handleCartUpdate();
              }

              // When a cart/change request sets quantity to 0 the item is
              // removed on Shopify's side but our silent-update override means
              // the row stays in the DOM. Detect this and refresh the drawer.
              if (url.includes('/cart/change')) {
                try {
                  const reqBody = JSON.parse(args[1]?.body || '{}');
                  if (Number(reqBody.quantity) === 0) {
                    refreshCartDrawer();
                  }
                } catch (_) {}
              }
            }
          } catch (e) {
            console.error('Error parsing cart response:', e);
          }
        }
        
        return response;
      }
      
      // For non-cart requests, proceed normally
      return originalFetch.apply(window, args);
    };

    // Start polling for cart changes
    this.startCartPolling();
  }

  startCartPolling() {
    // Initial cart state
    this.checkCartUpdates();

    // Poll every 2 seconds
    setInterval(() => this.checkCartUpdates(), 2000);
  }

  async checkCartUpdates() {
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();

      // Compare with previous state
      if (JSON.stringify(cart) !== JSON.stringify(this.previousCartState)) {
        const wasNotEmpty = (this.previousCartState.item_count ?? 0) > 0;
        const isNowEmpty = cart.item_count === 0;

        // During a clear→add upgrade the cart briefly looks empty to the poller.
        // Skip timer reset and empty-state side effects until the operation completes.
        if (!_cartBulkUpdating) {
          this.handleCartUpdate();
        }

        // Keep header item count and totals in sync on every cart change
        updateCartItemCount(cart.item_count);
        updateHeaderCartCount(cart.item_count);
        updateCartTotals(cart);
        updateFreeShippingMsg(cart);

        // Only update the announcement / trigger an empty-drawer refresh when
        // we are not in the middle of an intentional clear→add sequence.
        if (!_cartBulkUpdating) {
          updateCartAnnouncement(isNowEmpty);
          if (wasNotEmpty && isNowEmpty) {
            refreshCartDrawer();
          }
        }

        this.previousCartState = cart;
      }
    } catch (error) {
      console.error('Error checking cart updates:', error);
    }
  }

  handleCartUpdate() {
    this.setupTimer();
  }

  setupTimer() {
    // Clear any existing interval
    this.stopCountdown();

    // Get stored expiration time
    const storedExpiration = localStorage.getItem('cartExpirationTime');
    const hasItems = document.querySelector('cart-drawer-items:not(.is-empty)');

    if (hasItems) {
      // Wait for the cart-reservation element to be available
      this.waitForElement('#cart-reservation', () => {
        this.timerElement = document.getElementById('cart-reservation');
        
        // Get reservation time from data attribute
        const reservationTimeAttr = this.timerElement.getAttribute('data-cart-reservation-time');
        this.reservationTime = reservationTimeAttr ? parseInt(reservationTimeAttr) : 5; // Default to 10 if not set
        
        if (storedExpiration) {
          this.expirationTime = new Date(parseInt(storedExpiration));
          // If expiration time is in the past, clear it
          if (this.expirationTime <= new Date()) {
            this.clearCart();
            return;
          }
        } else {
          // Set new expiration time
          this.expirationTime = new Date(Date.now() + this.reservationTime * 60 * 1000);
          localStorage.setItem('cartExpirationTime', this.expirationTime.getTime().toString());
        }
        this.startCountdown();
      });
    } else {
      localStorage.removeItem('cartExpirationTime');
    }
  }

  waitForElement(selector, callback, maxTries = 10) {
    let tries = 0;
    const checkElement = () => {
      const element = document.querySelector(selector);
      if (element) {
        callback();
      } else if (tries < maxTries) {
        tries++;
        setTimeout(checkElement, 100);
      }
    };
    checkElement();
  }

  startCountdown() {
    if (!this.timerElement) return;

    // Update timer immediately
    this.updateTimer();

    // Start countdown interval
    this.countdownInterval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.expirationTime = null;
  }

  updateTimer() {
    if (!this.timerElement || !this.expirationTime) return;

    const now = new Date();
    const timeLeft = this.expirationTime - now;

    if (timeLeft <= 0) {
      this.clearCart();
      return;
    }

    const minutes = Math.floor(timeLeft / (60 * 1000));
    const seconds = Math.floor((timeLeft % (60 * 1000)) / 1000);

    this.timerElement.innerHTML = `Your cart will expire in <strong>${minutes}:${seconds.toString().padStart(2, '0')}</strong> minutes`;
  }

  async clearCart() {
    this.stopCountdown();
    localStorage.removeItem('cartExpirationTime');
    
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        refreshCartDrawer();
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }
}

// Initialize cart reservation when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.cartReservation = new CartReservation();
});

// Override CartDrawerItems to make quantity changes fully silent:
// no section re-fetch, no loading spinner, no disabled overlay.
document.addEventListener('DOMContentLoaded', function () {
  if (typeof CartDrawerItems !== 'undefined') {
    CartDrawerItems.prototype.getSectionsToRender = function () {
      return [];
    };
    CartDrawerItems.prototype.enableLoading = function () {};
    CartDrawerItems.prototype.disableLoading = function () {};
  }

  // Intentionally not subscribing to cartUpdate for cart-items source.
  // Quantity changes update silently — no section re-fetch, no DOM reload.

  // Sync the empty-cart icon with whatever SVG the header cart icon uses,
  // so custom icons set in header section settings are always reflected.
  syncEmptyCartIcon();
});

// Copy the header cart icon SVG into the empty-cart icon container so both
// always display the same icon (including any custom SVG from header settings).
function syncEmptyCartIcon() {
  const headerSvgWrapper = document.querySelector('#cart-icon-bubble .svg-wrapper');
  const emptyIconWrapper = document.querySelector('.cart-drawer__empty-icon');
  if (!headerSvgWrapper || !emptyIconWrapper) return;
  const clone = headerSvgWrapper.cloneNode(true);
  // Give it the same sizing classes the CSS targets
  const svg = clone.querySelector('svg');
  if (svg) {
    svg.classList.add('icon-cart-empty');
    svg.removeAttribute('width');
    svg.removeAttribute('height');
  }
  const existing = emptyIconWrapper.querySelector('svg, .svg-wrapper');
  if (existing) {
    existing.replaceWith(clone);
  } else {
    emptyIconWrapper.appendChild(clone);
  }
}




// document.addEventListener('DOMContentLoaded', function () {
//   document.addEventListener('click', async function (e) {
//     const btn = e.target.closest('.upsell-cta');
//     if (!btn) return;

//     const variantId = btn.getAttribute('data-id');
//     const sellingPlan = btn.getAttribute('data-selling-plan');
//     const packSize = parseInt(btn.getAttribute('data-pack-size'), 10);

//     // Helper: add to cart
//     const addToCart = async () => {
//       const body = {
//         items: [{
//           id: variantId,
//           quantity: 1,
//           ...(sellingPlan ? { selling_plan: sellingPlan } : {})
//         }]
//       };

//       const res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(body)
//       });

//       if (!res.ok) {
//         console.error('Failed to add item to cart');
//         return;
//       }

//       refreshCartDrawer();
//     };

//     // If pack size is 1 → just add, no need to clear cart
//     if (packSize === 1) {
//       await addToCart();
//       return;
//     }

//     // For packSize 2 or 3 → clear cart first
//     const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
//     if (!clearRes.ok) {
//       console.error('Failed to clear cart');
//       return;
//     }

//     // Now add the upsell product
//     await addToCart();
//   });
// });

// Upgrade upsell (1x→2x, 2x→3x, mixed→3x):
// Sums ALL item quantities in the current cart, clears it, then adds the
// upgraded pack at that total quantity so nothing is lost on upgrade.
// Example: 3×(1x) + 2×(2x) upgrading to 3x  →  clear  →  add 5×(3x)
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-cta');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    const originalHTML = btn.innerHTML;
    btn.innerHTML = '<span class="upsell-btn-spinner"></span>';
    btn.closest('.nw-cart-drawer_upsell-cover').classList.add('upsell--loading');

    const variantId = btn.getAttribute('data-id');
    const sellingPlan = btn.getAttribute('data-selling-plan');

    _cartBulkUpdating = true;
    try {
      // Step 1: fetch current cart and sum all item quantities
      const cartRes = await fetch('/cart.json');
      if (!cartRes.ok) throw new Error('Could not fetch cart');
      const cart = await cartRes.json();
      const totalQty = cart.items.reduce((sum, item) => sum + item.quantity, 0);

      // Step 2: clear the cart
      const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
      if (!clearRes.ok) throw new Error('Failed to clear cart');

      // Step 3: add the upgraded pack with the consolidated quantity
      const newItem = { id: variantId, quantity: totalQty };
      if (sellingPlan) {
        newItem.selling_plan = sellingPlan;
        newItem.properties = { Firstorderdate: '2025-12-15' };
      }

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [newItem] })
      });
      if (!addRes.ok) throw new Error('Failed to add upgraded pack');

      await refreshCartDrawer();
    } catch (err) {
      console.error('Error upgrading pack:', err);
      btn.disabled = false;
      btn.innerHTML = originalHTML;
      btn.closest('.nw-cart-drawer_upsell-cover').classList.remove('upsell--loading');
    } finally {
      _cartBulkUpdating = false;
    }
  });
});

// "Switch to 3x Pack" — sums ALL item quantities across the mixed cart,
// clears the cart, then adds that total quantity as a single 3x pack.
// Example: 3×1x + 4×2x + 1×3x  →  clear  →  add 8×3x
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-switch-3x-cta');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    const originalHTML = btn.innerHTML;
    btn.innerHTML = '<span class="upsell-btn-spinner"></span>';
    btn.closest('.nw-cart-drawer_upsell-cover').classList.add('upsell--loading');

    const variantId = btn.getAttribute('data-id');
    const sellingPlan = btn.getAttribute('data-selling-plan');

    _cartBulkUpdating = true;
    try {
      // Step 1: fetch current cart and sum all item quantities
      const cartRes = await fetch('/cart.json');
      if (!cartRes.ok) throw new Error('Could not fetch cart');
      const cart = await cartRes.json();
      const totalQty = cart.items.reduce((sum, item) => sum + item.quantity, 0);

      // Step 2: clear the cart
      const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
      if (!clearRes.ok) throw new Error('Failed to clear cart');

      // Step 3: add the 3x pack with the consolidated quantity
      const newItem = { id: variantId, quantity: totalQty };
      if (sellingPlan) {
        newItem.selling_plan = sellingPlan;
        newItem.properties = { Firstorderdate: '2025-12-15' };
      }

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [newItem] })
      });
      if (!addRes.ok) throw new Error('Failed to add 3x pack');

      await refreshCartDrawer();
    } catch (err) {
      console.error('Error switching to 3x:', err);
      btn.disabled = false;
      btn.innerHTML = originalHTML;
      btn.closest('.nw-cart-drawer_upsell-cover').classList.remove('upsell--loading');
    } finally {
      _cartBulkUpdating = false;
    }
  });
});

// "Add 1 more 3x pack" — increments quantity without clearing the cart
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-add-more-cta');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    const originalHTML = btn.innerHTML;
    btn.innerHTML = '<span class="upsell-btn-spinner"></span>';
    btn.closest('.nw-cart-drawer_upsell-cover').classList.add('upsell--loading');

    const variantId = btn.getAttribute('data-id');
    const sellingPlan = btn.getAttribute('data-selling-plan');

    const item = { id: variantId, quantity: 1 };
    if (sellingPlan) {
      item.selling_plan = sellingPlan;
      item.properties = { Firstorderdate: '2025-12-15' };
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });

      if (!res.ok) {
        console.error('Failed to add item to cart');
        btn.disabled = false;
        btn.innerHTML = originalHTML;
        btn.closest('.nw-cart-drawer_upsell-cover').classList.remove('upsell--loading');
        return;
      }

      refreshCartDrawer();
    } catch (err) {
      console.error('Error adding to cart:', err);
      btn.disabled = false;
      btn.innerHTML = originalHTML;
      btn.closest('.nw-cart-drawer_upsell-cover').classList.remove('upsell--loading');
    }
  });
});
